import {
  RouteRef,
  SubRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  recordings = 'recordings',
  recording = 'recordings-recording',
  explorer = 'recordings-explorer',
}

export const rootRouteRef = createRouteRef({
  id: RoutesIds.recordings,
});

export const recordingRouteRef = createSubRouteRef({
  id: RoutesIds.recording,
  parent: rootRouteRef,
  path: '/:id',
});

export const explorerRouteRef = createSubRouteRef({
  id: RoutesIds.explorer,
  parent: rootRouteRef,
  path: '/explorer',
});

export const Routes = {
  [RoutesIds.recordings]: rootRouteRef,
  [RoutesIds.recording]: recordingRouteRef,
  [RoutesIds.explorer]: explorerRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;
